import { auth } from '@/firebase';

const FUNCTIONS_BASE_URL = 'https://asia-northeast3-studentremark-helper.cloudfunctions.net';

async function callAuthenticatedFunction(name, body) {
  const user = auth.currentUser;
  if (!user) {
    throw new Error('로그인이 필요합니다.');
  }

  const idToken = await user.getIdToken();
  const response = await fetch(`${FUNCTIONS_BASE_URL}/${name}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${idToken}`,
    },
    body: JSON.stringify(body),
  });
  const payload = await response.json().catch(() => ({}));
  if (!response.ok) {
    throw new Error(payload.error || '요청을 처리하지 못했습니다.');
  }
  return payload;
}

export function completeUserRegistration(profile) {
  return callAuthenticatedFunction('completeUserRegistration', profile);
}

export function grantCreditEvent(payload) {
  return callAuthenticatedFunction('grantCreditEvent', payload);
}

export function getAccountCreditHistory(payload) {
  return callAuthenticatedFunction('getAccountCreditHistory', payload);
}

export function getWelcomeEmailCampaignState() {
  return callAuthenticatedFunction('getWelcomeEmailCampaignState', {});
}

export function getWelcomeEmailTemplate() {
  return callAuthenticatedFunction('getWelcomeEmailTemplate', {});
}

export function saveWelcomeEmailTemplate(template) {
  return callAuthenticatedFunction('saveWelcomeEmailTemplate', { template });
}

export function initializeWelcomeEmailCampaignState(baselineUid) {
  return callAuthenticatedFunction('initializeWelcomeEmailCampaignState', { baselineUid });
}

export function prepareWelcomeEmailCampaign() {
  return callAuthenticatedFunction('prepareWelcomeEmailCampaign', {});
}

export function getWelcomeEmailCampaignRecipients(campaignId) {
  return callAuthenticatedFunction('getWelcomeEmailCampaignRecipients', { campaignId });
}

export function getWelcomeEmailCampaignSendPayload(campaignId) {
  return callAuthenticatedFunction('getWelcomeEmailCampaignSendPayload', { campaignId });
}

export function completeWelcomeEmailCampaign(campaignId) {
  return callAuthenticatedFunction('completeWelcomeEmailCampaign', { campaignId });
}

export function cancelWelcomeEmailCampaign(campaignId) {
  return callAuthenticatedFunction('cancelWelcomeEmailCampaign', { campaignId });
}
